var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main w-per100 minvh100 bg_w column a-center"},[_c('h1',{staticClass:"seo-h1"},[_vm._v(_vm._s(_vm.PageTitle || '佰信纸业 - 专业纸品制造与服务商'))]),_c('MyNav',{attrs:{"current":_vm.current}}),_c('Banner'),_c('About'),_c('Product'),_c('News'),_c('ShowImgs'),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }